import { render, staticRenderFns } from "./CouponListActive.vue?vue&type=template&id=2d4436a8&"
import script from "./CouponListActive.vue?vue&type=script&lang=js&"
export * from "./CouponListActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports